// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Xy8Ci","col":"styles_col__fPrgZ"};